// import React, { useState } from "react";
// import AppInput from "components/app-input";
// import AppItemDropdown from "components/app-item-dropdown";
import React from "react";
import { useContext, useEffect, useState } from "react";
// components
import MyTextInput from "components/input";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import AppCustomToast, { PageContext } from "components/app-custom-toast";
// commons
import CONSTANSTS from "common/constansts";

const PageLoanSettings = () => {
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  const defaultValue = {
    creditActiveDays: "",
    interestRate: "",
    loanAmountDenominator: "1",
    maxLoanAmount: "",
    maxLoanPeriod: "",
    minLoanAmount: "",
    minLoanPeriod: "",
    minTransactionAmount: "",
    coolingPeriodMonths: "",
    maxLoanReject: "",
  };

  //select options default values
  const options = [
    //  { code: "1", label: "1", sortOrder: "1" },
    //  { code: "10", label: "10", sortOrder: "2" },
    //  { code: "100", label: "100", sortOrder: "3" },
    //  { code: "1000", label: "1000", sortOrder: "4" },
    //  { code: "10000", label: "10000", sortOrder: "5" },
    { code: "", label: "", sortOrder: "" },
  ];

  //dynamically assigns select options data
  function Options({ options }) {
    return options.map((option) => (
      <option key={option.code} value={option.label}>
        {option.label}
      </option>
    ));
  }

  //fetch updated/latest loan settings data
  const [data, setData] = useState();
  const [optionsData, setOptionsData] = useState();
  useEffect(async () => {
    try {
      let token = null;
      token = localStorage.getItem("@storage_token");
      let code = "LOAN_DENOMINATOR";
      fetch(
        // "http://49.0.203.50/ivc-app/bo/settings/api/v1/getLoanCalculator",
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_LOAN_CALCULATOR,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          if (result !== null || result !== undefined) {
            setData(result.result);
          } else {
            setData(defaultValue);
          }
        });
      fetch(
        // "http://49.0.203.50/ivc-app/bo/settings/api/v1/findDropdownOption/" +
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.FIND_DROPDOWN_OPTION + code,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          if (result !== null || result !== undefined) {
            setOptionsData(result.result);
          } else {
            setOptionsData(options);
          }
        });
    } catch (error) {
      console.log("error", error);
    }
  }, []);

  const validationMsg = {
    field_required: "This field cannot be empty",
    integer: "Value must be an integer",
    minimum_value: "Value cannot be lower than",
    maximum_value: "Value cannot be more than",
    more_than: "Value more than",
  };

  const validation = Yup.object({
    creditActiveDays: Yup.number()
      .min(1, validationMsg.minimum_value + " 1")
      .max(100, validationMsg.more_than + " 100")
      .required(validationMsg.field_required)
      .integer(validationMsg.integer),
    interestRate: Yup.number()
      .min(0.01, validationMsg.minimum_value + " 0.01")
      .max(100,validationMsg.more_than+" 100")
      .required(validationMsg.field_required),
    loanAmountDenominator: Yup.string().required(validationMsg.field_required),
    maxLoanAmount: Yup.number()
      .moreThan(Yup.ref("minLoanAmount"), validationMsg.more_than + " minimum")
      .required(validationMsg.field_required)
      .integer(validationMsg.integer),
    maxLoanPeriod: Yup.number()
      .moreThan(Yup.ref("minLoanPeriod"), validationMsg.more_than + " minimum")
      .max(100,validationMsg.more_than+" 100")
      .required(validationMsg.field_required),
    minLoanAmount: Yup.number()
      .min(1, validationMsg.minimum_value + " 1")
      .required(validationMsg.field_required)
      .integer(validationMsg.integer),
    minLoanPeriod: Yup.number()
      .min(1, validationMsg.minimum_value + " 1")
      .required(validationMsg.field_required)
      .integer(validationMsg.integer),
    minTransactionAmount: Yup.number()
      .min(1, validationMsg.minimum_value + " 1")
      .max(100, validationMsg.more_than + " 100")
      .required(validationMsg.field_required)
      .integer(validationMsg.integer),
    coolingPeriodMonths: Yup.number()
      .min(1, validationMsg.minimum_value + " 1")
      .max(100,validationMsg.more_than+" 100")
      .required(validationMsg.field_required),
    maxLoanReject: Yup.number()
      .min(1, validationMsg.minimum_value + " 1")
      .max(100,validationMsg.more_than+" 100")
      .required(validationMsg.field_required),
  });

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={data}
        // values={data}
        validationSchema={validation}
        onSubmit={(defaultValue, { setSubmitting }) => {
          console.log("submit");
          let token = null;
          token = localStorage.getItem("@storage_token");

          //setTimeout(() => {
          fetch(
            // "http://49.0.203.50/ivc-app/bo/settings/api/v1/updateLoanCalculator",
            process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_LOAN_CALCULATOR,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
                "Accept-language": "en", "X-DEVICE-OS": "Web",
                Authorization: "Bearer " + token,
              },
              body: JSON.stringify(defaultValue, null, 2),
            }
          )
            .then((response) => response.json())
            .then((response) => {
              if (response.responseCode == 200) {
                messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: response.message });
              } else {
                messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: response.message, defaultOnClick: false });
              }
            });

          //alert("Update Successfully!", window.location.reload(false));
          console.log(setSubmitting);
          //  setSubmitting(true);
          //}, 400);
        }}
      >
        <div className="page-loan-settings">
          <div className="row">
            <div className="col-6 green">
              <div className="loan-settings__left-photo">
                <div className="left-content">
                  <div>Loan</div>
                  <div>Settings</div>
                </div>
              </div>
            </div>

            <Form className="loan-settings__right-cal col-6 ">
              <div className="right-box right-content">
                <div className="col">
                  <div className="row-8 line">
                    <div className="row">
                      <div className="col-3">Calculator Denominator</div>
                      <div className="col-4 ">
                        <div className="row cal-demo">
                          <div className="col-4 cal-demo-content c-orange w-medium">RM</div>

                          {/* <MyTextInput type="select" name="loanAmountDenominator">
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                    </MyTextInput> */}
                          <MyTextInput className="col cal-demo-content-ddl w-light" type="select" name="loanAmountDenominator">
                            <Options options={optionsData || options} />
                          </MyTextInput>
                        </div>
                      </div>
                    </div>

                    <div className="row min-max c-orange w-bold">
                      <div className="col-6 min c-beige">Minimum</div>
                      <div className="col-6">Maximum</div>
                    </div>

                    <div>Loan Amount</div>

                    <div className="row ">
                      <div className="col-5 ">
                        <div className="row min-max-loan-amount ">
                          <div className="col-4 min-loan-amount-content c-beige w-medium">RM</div>
                          <MyTextInput className="col input-field-number w-light white rm-input-box" placeholder="XXXX" type="number-1" name="minLoanAmount" />
                        </div>
                      </div>
                      <div className="col-2 to w-medium"> to</div>
                      <div className="col-5">
                        <div className="row min-max-loan-amount">
                          <div className="col-4 min-loan-amount-content c-orange w-medium">RM</div>

                          <MyTextInput className="col input-field-number w-light white rm-input-box" placeholder="XXXX" type="number-1" name="maxLoanAmount" />
                        </div>
                      </div>
                    </div>

                    <div>Tenure</div>

                    <div className="row ">
                      <div className="col-5 ">
                        <div className="row tenure-year">
                          <div className="col-6 min-year-content c-beige w-medium">Years</div>
                          <MyTextInput className="col input-field-number-2 w-light white years-input-box" placeholder="XXXX" type="number-2" name="minLoanPeriod" />
                        </div>
                      </div>
                      <div className="col-2 to w-medium"> to</div>
                      <div className="col-5">
                        <div className="row tenure-year">
                          <div className="col-6 min-year-content c-orange w-medium">Years</div>
                          <MyTextInput className="col input-field-number-2 w-light white years-input-box" placeholder="XXXX" type="number-2" name="maxLoanPeriod" />
                        </div>
                      </div>
                    </div>
                    <div>Interest Rate</div>
                    <div className="row ">
                      <div className="col-5">
                        <div className="row interest-rate-content">
                          <div className="col-4 percentage c-beige w-medium">%</div>
                          <MyTextInput className="col input-field-decimal-number w-light white rm-input-box" placeholder="XX.XX" type="decimal-number" name="interestRate" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row-4 line">
                    <div className="row">
                      <div className="col-7">
                        <div>Minimum Transaction Amount</div>
                        <div className="row  tenure-year">
                          <div className="col-3 min-year-content c-beige w-medium">%</div>
                          <MyTextInput className="col-6 input-field-number-2 w-light white percentage-input-box" placeholder="XXX" type="number-2" name="minTransactionAmount" />
                        </div>
                      </div>

                      <div className="col-5 ">
                        <div>Credit Active</div>
                        <div className="row tenure-year">
                          <div className="col-6 min-year-content c-beige w-medium">Days</div>
                          <MyTextInput className="col-6 input-field-number-2 w-light white days-input-box" placeholder="XXXX" type="number-2" name="creditActiveDays" />
                        </div>
                      </div>
                    </div>
                </div>
                <div className="row-5">
                    <div className="row">
                      <div className="col-7">
                        <div>Max Loan Reject</div>
                        <div className="row  tenure-year">
                          <div className="col-3 min-year-content c-beige w-medium">Times</div>
                          <MyTextInput className="col-6 input-field-number-2 w-light white percentage-input-box" placeholder="XXX" type="number-2" name="maxLoanReject" />
                        </div>
                      </div>

                      <div className="col-5 ">
                        <div>Cooling Period</div>
                        <div className="row tenure-year">
                          <div className="col-6 min-year-content c-beige w-medium">Months</div>
                          <MyTextInput className="col-6 input-field-number-2 w-light white days-input-box" placeholder="XXXX" type="number-2" name="coolingPeriodMonths" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="button mb-5">
                <button className="update-button w-bold c-beige mb-5" type="submit">
                  Update
                </button>
              </div>
            </Form>
          </div>
        </div>
      </Formik>
    </>
  );
};

export default PageLoanSettings;
